export const READ_REPORTS = 'READ_REPORTS';
export const CREATE_REPORT = 'CREATE_REPORT';
export const UPDATE_REPORT = 'UPDATE_REPORT';
export const DELETE_REPORT = 'DELETE_REPORT';

export const readReportsAction = (
  // eslint-disable-next-line no-shadow
  reports,
  queryId = 'default',
) => ({
  type: READ_REPORTS,
  payload: {
    reports,
    queryId,
  },
});

export const createReportAction = (report, queryId = 'default') => ({
  type: CREATE_REPORT,
  payload: {
    report,
    queryId,
  },
});

export const updateReportAction = (report, queryId = 'default') => ({
  type: UPDATE_REPORT,
  payload: {
    report,
    queryId,
  },
});

export const deleteReportAction = (reportId, queryId = 'default') => ({
  type: DELETE_REPORT,
  payload: {
    reportId,
    queryId,
  },
});

const initialReports = { default: {} };

export function reports(state = initialReports, action) {
  switch (action.type) {
    case READ_REPORTS: {
      const newState = {
        ...state,
        [action.payload.queryId]: { ...state[action.payload.queryId] },
      };
      action.payload.reports.forEach((p) => {
        newState[action.payload.queryId][p._id] = p;
      });
      return newState;
    }
    case CREATE_REPORT:
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.report._id]: action.payload.report,
        },
      };
    case UPDATE_REPORT: {
      const current =
        (state[action.payload.queryId] &&
          state[action.payload.queryId][action.payload.report._id]) ||
        undefined;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.report._id]: {
            ...current,
            ...action.payload.report,
          },
        },
      };
    }
    case DELETE_REPORT: {
      const { reportId } = action.payload;
      return Object.entries(state).reduce((prev, [key, val]) => {
        prev[key] = {
          ...val,
          [reportId]: undefined,
        };
        return prev;
      }, {});
    }
    default:
      return state;
  }
}
